import React from 'react';

import Tooltip from '../../Tooltip';
import classes from './styles.module.scss';
import editIcon from '../../../assets/images/my-meetings/edit2.svg';
import deleteIcon from '../../../assets/images/my-meetings/delete.svg';
import usersIcon from '../../../assets/images/my-meetings/users.svg';

export default function TableRowAction({
  handleDelete,
  handleEdit,
  handleManageAccess,
  noEdit,
  noManageAccess,
  canEdit,
  canDelete,
  canManageAccess,
  meetingId,
  disabled,
  disabledTooltip,
}) {
  const editButton = (
    <button
      type="button"
      className={`${classes.button} ${disabled ? classes.disabled : ''}`}
      onClick={disabled ? undefined : handleEdit}
      disabled={disabled}
      data-testid={meetingId ? `edit-meeting-button-${meetingId}` : 'edit-meeting-button'}
    >
      <img src={editIcon} alt="Edit" />
    </button>
  );

  const deleteButton = (
    <button
      className={`${classes.button} ${disabled ? classes.disabled : ''}`}
      type="button"
      onClick={disabled ? undefined : handleDelete}
      disabled={disabled}
      data-testid={meetingId ? `delete-meeting-button-${meetingId}` : 'delete-meeting-button'}
    >
      <img src={deleteIcon} alt="Delete" />
    </button>
  );

  return (
    <div
      className={classes.TableRowAction}
      onClick={(event) => {
        event.stopPropagation();
      }}
    >
      {!noEdit && canEdit && (
        disabled && disabledTooltip
          ? <Tooltip text={disabledTooltip} position="left">{editButton}</Tooltip>
          : editButton
      )}
      {!noManageAccess && handleManageAccess && canManageAccess && (
        <button
          type="button"
          className={classes.button}
          onClick={handleManageAccess}
          data-testid={meetingId ? `manage-access-button-${meetingId}` : 'manage-access-button'}
        >
          <img src={usersIcon} alt="Manage access" />
        </button>
      )}
      {canDelete && (
        disabled && disabledTooltip
          ? <Tooltip text={disabledTooltip} position="left">{deleteButton}</Tooltip>
          : deleteButton
      )}
    </div>
  );
}
